/* eslint-disable react/prop-types */
import React from 'react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import HERO_SECTION_SLIDE_2_MOBILE from '../../assets/images/hero-slide-2-mobile.png';
import HERO_SECTION_SLIDE_2 from '../../assets/images/hero-slide-2.png';
import ICON_ARROW_DOWN from '../../assets/images/icon_arrow_down.png';
import ICON_ARROW_RIGHT from '../../assets/images/icon_arrow_right.png';
import IMAGE_CART from '../../assets/images/image_cart.png';
import IMAGE_MEDICINE from '../../assets/images/image_medicine.png';
import './LandingPageContent.css';

const scrollTo = (section, container) => {
  const destination = document.getElementById(section);

  if (destination) {
    destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
  } else {
    const destinations = document.querySelectorAll(container);
    if (destinations && destinations.length > 0) {
      destinations[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
};

function renderHeader() {
  return (
    <div className='landing-header'>
      <div className='landing-title'>มียา.com</div>
      <div className='landing-subtitle'>
        บริการช่วยเหลือการซื้อขายสินค้าระหว่างร้านขายยา ให้การหาสินค้าเข้าร้านเป็นเรื่องง่าย
      </div>
      <div className='landing-description'>
        พื้นที่แลกเปลี่ยนสินค้าสำหรับผู้ประกอบการธุรกิจ ด้านสุขภาพ ที่ได้รับใบอนุญาต
        <br />
        เช่น ร้านขายยา คลินิก สถานพยาบาล โรงพยาบาล คลินิกสัตว์แพทย์ คลินิกทันตกรรม
      </div>
    </div>
  );
}

function RenderLabel({ type, image, title, subtitle, description, onActionClick }) {
  const handleClick = () => {
    if (onActionClick) {
      onActionClick(type);
    }
  };

  return (
    <button
      className={`landing-label-button ${type === 'buy' ? 'buy-button' : 'sell-button'}`}
      onClick={handleClick}
    >
      <div className='landing-label-content'>
        <img className='landing-label-image' alt='' src={image} />
        <div className='landing-label-info'>
          <div className='landing-label-title-container'>
            <div className='landing-label-title'>
              <span className='landing-label-title-bold'>{title}</span>
              <b className='landing-label-subtitle'>
                <span>{` `}</span>
                <span>{subtitle}</span>
              </b>
            </div>
            <div className='landing-label-description'>{description}</div>
          </div>
          <div className='landing-label-details'>
            <div className='landing-label-details-text'>รายละเอียด</div>
            <img className='landing-label-arrow' alt='' src={ICON_ARROW_RIGHT} />
          </div>
        </div>
      </div>
    </button>
  );
}
const swiperParams = {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
};

const LandingPageContent = ({ callback_popup_register }) => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 1024);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Swiper
      {...swiperParams}
      modules={[Autoplay]}
      className='meya-landing-container'
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
    >
      <SwiperSlide>
        <div className='meya-label-container'>
          <div className='d-flex flex-column gap-3 justify-center label-header-container'>
            {renderHeader()}
            <div className='mobile-register-container'>
              <button className='mobile-register-button' onClick={callback_popup_register}>
                สมัครใช้งานฟรี
              </button>
            </div>
            <div className='d-flex flex-column gap-3 align-items-center label-buttons-group'>
              <RenderLabel
                type='buy'
                image={IMAGE_CART}
                title={`"ซื้อ"`}
                subtitle='สินค้าที่ดีที่สุด'
                description='หาง่าย เลือกได้ ขายไว ชุมชนสำหรับร้านยา และคลินิกสำหรับซื้อขายยาและเวชภัณฑ์'
                onActionClick={() => scrollTo('landing-buy-section', '.landing-buy-container')}
              />

              <RenderLabel
                type='sell'
                image={IMAGE_MEDICINE}
                title={`"ขาย"`}
                subtitle='สินค้ากับเรา'
                description='ติดปีกร้านยาให้เป็นร้านค้าส่ง ง่ายแค่ปลายนิ้ว มีของเยอะขายไม่ทัน ปล่อยได้ที่ มียา'
                onActionClick={() => scrollTo('landing-sell-section', '.landing-sell-container')}
              />
            </div>
          </div>
        </div>
      </SwiperSlide>
      {!isMobile && (
        <SwiperSlide
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img
            className='d-block-sm self-center'
            src={HERO_SECTION_SLIDE_2_MOBILE}
            style={{ height: '100vh', alignSelf: 'center' }}
          />
          <img className='d-block-lg' src={HERO_SECTION_SLIDE_2} style={{ height: '95vh' }} />
        </SwiperSlide>
      )}
      <div className='landing-scroll-button-container'>
        <button
          className='landing-scroll-button'
          onClick={() => scrollTo('landing-buy-section', '.landing-buy-container')}
        >
          <img className='landing-scroll-arrow' alt='' src={ICON_ARROW_DOWN} />
        </button>
      </div>
    </Swiper>
  );
};

export default LandingPageContent;
